import type { Service } from '../redux/types.ts';
import { getCurrentUserEmail } from './tokenUtils.ts';

interface RecentService {
  path: string;
  title: string;
}

export const saveRecentService = (service: Service) => {
  const recentServices = getRecentServices();
  const newRecentServices = [
    { path: service.path, title: service.title },
    ...recentServices.filter(s => s.path !== service.path),
  ];

  const email = getCurrentUserEmail();
  const allRecentServices = getAllRecentServices();

  allRecentServices[email || 'default'] = newRecentServices.slice(0, 3);
  try {
    localStorage.setItem('recentServices', JSON.stringify(allRecentServices));
  } catch (e) {
    localStorage.setItem('recentServices', JSON.stringify({}));
  }
};

const getAllRecentServices = () => {
  const recentServices = localStorage.getItem('recentServices');

  if (!recentServices) {
    return {};
  }

  try {
    return JSON.parse(recentServices);
  } catch (e) {
    localStorage.setItem('recentServices', JSON.stringify({}));
    return {};
  }
};

export const getRecentServices = (): RecentService[] => {
  const email = getCurrentUserEmail();
  const recentServices = localStorage.getItem('recentServices');

  if (!recentServices) {
    return [];
  }

  try {
    const recentServicesObj = JSON.parse(recentServices);
    return recentServicesObj[email || 'default'] || [];
  } catch (e) {
    localStorage.setItem('recentServices', JSON.stringify({}));
    return [];
  }
};
